<template>
  <div class="card card-secondary card-outline mb-4 mt-4">
    <!--begin::Header-->
    <div class="card-header"><div class="card-title">عرض البيانات</div></div>
    <!--end::Header-->
    <!--begin::Form-->
    <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber" />
    <successAlert v-if="hasSucess" :message="message" />
    <!--begin::Body-->
    <div class="card-body">
      <div class="row">
        <div class="col-12 col-sm-6 mb-3">
          <label for="" class="form-label">الاسم:</label>
          <div>{{ dataRow.User.name }}</div>
        </div>
        <div class="col-12 col-sm-6 mb-3">
          <label for="" class="form-label">رقم الجوال:</label>
          <div>{{ dataRow.User.mobile }}</div>
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-sm-6 mb-3">
          <label for="" class="form-label">العقار:</label>
          <div>
            <router-link :to="`/properties/update/${dataRow.propertyId}`">{{ dataRow.Property.title }}</router-link>
          </div>
        </div>
        <div class="col-12 col-sm-6 mb-3">
          <label for="" class="form-label">طلب التمويل:</label>
          <div>{{ (dataRow.financingRequest)? 'نعم' : 'لا' }}</div>
        </div>
      </div>

      <div class="row">
        <div class="col-12 mb-3">
          <div class="form-head"><i class="bi bi-chevron-left"></i> البيانات في حالة طلب التمويل:</div>
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-sm-6 mb-3">
          <label for="" class="form-label">الاسم بالكامل:</label>
          <div>{{ dataRow.fullName }}</div>
        </div>
        <div class="col-12 col-sm-6 mb-3">
          <label for="" class="form-label">الجوال:</label>
          <div>{{ dataRow.mobile }}</div>
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-sm-6 mb-3">
          <label for="" class="form-label">الراتب:</label>
          <div>{{ dataRow.salary }}</div>
        </div>
        <div class="col-12 col-sm-6 mb-3">
          <label for="" class="form-label">الإلتزامات:</label>
          <div>{{ dataRow.obligations }}</div>
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-sm-6 mb-3">
          <label for="" class="form-label">تاريخ الطلب:</label>
          <div class="date-format">{{ formatDate(dataRow.createdAt) }}</div>
        </div>
        <div class="col-12 col-sm-6 mb-3">
          <label for="" class="form-label">بيانات السداد:</label>
          <div>
            <router-link :to="`/payments/update/${dataRow.paymentId}`">عرض بيانات السداد</router-link>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-sm-6 mb-3">
          <label for="" class="form-label">حالة الطلب:</label>
          <div>{{ statusChoices[status] }}</div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-sm-6 mb-3">
          <label for="" class="form-label">مصدر الطلب:</label>
          <div>
            <span v-if="dataRow.requestSource === 'admin'" class="badge bg-secondary">Admin</span>
            <span v-else-if="dataRow.requestSource === 'ios'" class="badge bg-primary">IOS</span>
            <span v-else-if="dataRow.requestSource === 'android'" class="badge bg-primary">Android</span>
            <span v-else-if="dataRow.requestSource === 'website'" class="badge bg-info">Website</span>
            <span v-else-if="dataRow.requestSource" class="badge bg-light text-dark">{{ dataRow.requestSource }}</span>
            <span v-else class="text-muted">غير محدد</span>
          </div>
        </div>
      </div>
      <!-- Coupon Section -->
      <div class="row">
        <div class="col-12 mb-2">
          <div class="form-head"><i class="bi bi-chevron-left"></i> بيانات الكوبون:</div>
        </div>
      </div>
      <div v-if="dataRow.couponAccepted && dataRow.Coupon" class="row">
        <div class="col-12 col-sm-6 mb-3">
          <label class="form-label">كود الكوبون:</label>
          <div><span class="badge bg-success fs-6">{{ dataRow.Coupon.code }}</span></div>
        </div>
        <div class="col-12 col-sm-6 mb-3">
          <label class="form-label">وصف الكوبون:</label>
          <div>{{ dataRow.Coupon.title }}</div>
        </div>
        <div class="col-12 col-sm-6 mb-3">
          <label class="form-label">نوع الخصم:</label>
          <div>{{ dataRow.couponType === 'percentage' ? 'نسبة مئوية' : 'قيمة ثابتة' }}</div>
        </div>
        <div class="col-12 col-sm-6 mb-3">
          <label class="form-label">قيمة الخصم:</label>
          <div>{{ dataRow.couponAmount }} {{ dataRow.couponType === 'percentage' ? '%' : 'ريال' }}</div>
        </div>
        <div class="col-12 col-sm-6 mb-3">
          <label class="form-label">سعر العقار الأصلي:</label>
          <div>{{ dataRow.Property ? Number(dataRow.Property.price).toLocaleString() : '-' }} ريال</div>
        </div>
        <div class="col-12 col-sm-6 mb-3">
          <label class="form-label">السعر بعد الخصم:</label>
          <div class="text-success fw-bold">{{ Number(dataRow.priceAfterDiscount).toLocaleString() }} ريال</div>
        </div>
      </div>
      <div v-else class="row">
        <div class="col-12 mb-3">
          <span class="text-muted">لم يتم استخدام كوبون خصم في هذا الحجز</span>
        </div>
      </div>
    </div>
    <!--end::Body-->
  </div>
</template>

<script>
import { formatDate } from '@/helpers/tools';

export default {
  name: 'BookingView',
  props: {
    dataRow: {
      type: Object,
      default: null,
    },
    statusObject: {
      type: Object,
      default: null,
    },
  },
  data(){
    return {
      formLoader: false,
      hasError: false,
      hasSucess: false,
      message: '',
      errorNumber: 0,
      statusChoices: {},
      status: 'new',
    }
  },
  methods: {
    formatDate,
  },
  created(){
    if(this.dataRow){
      this.status = this.dataRow.status;
    }
    this.statusChoices = this.statusObject;
  }
}
</script>
